export default "__VITE_ASSET__DlaRBGcz__"